import { mergeAcknowledgementGroup } from './mergeAckGroup';
import { flatMap, groupBy, map } from 'lodash';
import { Acknowledgement, AcknowledgementForSingleCve } from 'types';

/** Takes in loose acknowledgement data, and groups researchers acknowledgements
 * together by CVE number.
 *
 * @param data Acks to process into CVEAcks
 * @returns CVEAcks
 */
export const groupAcksByCveNumber = (
  data: Acknowledgement[] | undefined
): AcknowledgementForSingleCve[] | undefined => {
  if (!data) {
    return undefined;
  }
  const dataByCveNumber = groupBy(data, 'cveNumber');

  return flatMap(dataByCveNumber, (value, cveNumber) => {
    //Items without a CVE number should be processed as individual rows
    if (!cveNumber || cveNumber === 'undefined') {
      return map(value, a => mergeAcknowledgementGroup([a]));
    }
    return mergeAcknowledgementGroup(value);
  });
};
